import { GAME_CONFIG } from '../config';

const HIGH_SCORE_KEY = 'edublox_high_score';

// Points per number of cleared lines: 1 → 100, 2 → 200, 3 → 400, 4+ → 800
const LINE_POINTS = [100, 200, 400, 800];

export class Scoring {
  private score = 0;
  private highScore: number;

  constructor() {
    this.highScore = this.loadHighScore();
  }

  /**
   * Calculate points for a given number of cleared lines.
   */
  calculatePoints(totalLines: number): number {
    if (totalLines <= 0) return 0;
    const index = Math.min(totalLines, LINE_POINTS.length) - 1;
    return LINE_POINTS[index];
  }

  /**
   * Add points to the score and update the high score if needed.
   */
  addPoints(points: number): void {
    if (points <= 0) return;
    this.score += points;
    if (this.score > this.highScore) {
      this.highScore = this.score;
      this.saveHighScore();
    }
  }

  /**
   * Apply the ×5 multiplier when the board is cleared completely.
   */
  applyCleanBoardMultiplier(): void {
    this.score *= GAME_CONFIG.scoring.cleanBoardMult;
    if (this.score > this.highScore) {
      this.highScore = this.score;
      this.saveHighScore();
    }
  }

  reset(): void {
    this.score = 0;
  }

  getScore(): number {
    return this.score;
  }

  getHighScore(): number {
    return this.highScore;
  }

  private loadHighScore(): number {
    try {
      const stored = localStorage.getItem(HIGH_SCORE_KEY);
      if (stored !== null) {
        const parsed = parseInt(stored, 10);
        return Number.isFinite(parsed) ? parsed : 0;
      }
    } catch {
      // localStorage unavailable
    }
    return 0;
  }

  private saveHighScore(): void {
    try {
      localStorage.setItem(HIGH_SCORE_KEY, String(this.highScore));
    } catch {
      // localStorage unavailable
    }
  }
}